import { useResolveUserQuery } from '@graphql/generated';
import { TextV2 } from '@withjoy/joykit';
import React from 'react';

type UsernameProps = {
  id: string | undefined;
};

export const Username = (props: UsernameProps) => {
  const { data } = useResolveUserQuery({
    variables: {
      userId: props.id ?? '',
    },
    batchMode: 'off',
  });

  return <TextV2>{`${data?.user?.firstName ?? ''} ${data?.user?.lastName ?? ''} ${data?.user?.email}`}</TextV2>;
};
